'use client';

import { styled } from 'styled-components';
import * as Styled from '@lib/styles';
import Link from 'next/link';
import { trackLink } from '@lib/tracking';

const HomepagePromoContainer = styled(Link)`
  align-items: center;
  background: ${({ theme }) =>
    `linear-gradient(to right, ${theme.colors.blue400}, ${theme.colors.blue500})`};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing[0.5]};
  padding-block: ${({ theme }) => theme.spacing[0.75]};
  padding-inline: ${({ theme }) => theme.spacing[1]};
  position: relative;

  h4 {
    margin: 0;

    &::after {
      content: '→';
      display: inline-block;
      margin-inline-start: ${({ theme }) => theme.spacing['0.5']};
      transition: transform 250ms ease-in-out;
    }
  }

  &:hover {
    h4 {
      text-decoration: underline;
      &::after {
        transform: translateX(${({ theme }) => theme.spacing['0.25']});
      }
    }
  }

  ${({ theme }) => theme.mq.minWidth.large} {
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing[1.25]};
    padding-inline: ${({ theme }) => theme.spacing[4]};
  }
`;

const HomepagePromoPill = styled.div`
  background-color: transparent;
  border: 2px solid ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radius.std};
  box-shadow: 0px 0px 8px 0px ${({ theme }) => theme.colors.blue200};
  color: ${({ theme }) => theme.colors.white};
  padding-block: ${({ theme }) => theme.spacing[0.25]};
  padding-inline: ${({ theme }) => theme.spacing[1]};

  p {
    margin: 0;
    font-weight: ${({ theme }) => theme.typography.fontWeight.headingFour};
  }
`;

/**
 * The homepage promo is a link that displays a gradient background and a pill with a new badge.
 * It is displayed on the homepage. When adding new content please update the constant
 * MOBILE_NAVBAR_OFFSET_WITH_HOMEPAGE_PROMO in @lib/constants.ts to account for the content and any shifts in height.
 */
const HomepagePromo = () => {
  const handleClick = () => {
    trackLink('homepage-banner', 'homepage');
  };

  return (
    <HomepagePromoContainer
      href="/explore/state-of-video-report?utm_source=storefront&utm_medium=homepage-banner&utm_campaign=state-of-video-2026"
      onClick={handleClick}
    >
      <HomepagePromoPill>
        <Styled.BodySm>Wed, Apr 22 @  11 AM EDT</Styled.BodySm>
      </HomepagePromoPill>
      <h4>The State of Video Live Show</h4>
    </HomepagePromoContainer>
  );
};

export default HomepagePromo;
